<template>
  <div class="event-list">
    
    <div class="event-list-container" ref="eventListContainer">
      <!-- 标题 -->
      <div style="display: flex;align-items: center;" @click="navBack">
          <img :src="$staticUrl('/statics/2025/09/13/return_20250913141253A062.png')" alt="" style="width: 14px;height: 14px;vertical-align: bottom;"></img>
          <div style="color: #fff; margin-left: 5px;font-size: 15px;">返回</div>
      </div>

      <!-- 事件列表 -->
      <div class="event-items">
        <!-- 处理中事件 -->
        <!-- 使用ref替代ID，更安全的获取方式 -->
        <div class="scroll-wrapper">
            <div class="title">{{info.applicationTypeValue}}</div>
            <div style="margin-top: 20px;display: flex;align-items: center;">
              <div style="width: 8px;height: 8px;border-radius: 50%;margin-right: 5px;background-color: #00FFF7;"></div>
              <div style="font-size: 14px;color: #ccc;">申请原因</div>
            </div>
            <div style="margin-top: 5px;">
              <div style="font-size: 14px;color: #fff;">{{info.applicationReason}}</div>
            </div>
            <div style="margin-top: 20px;display: flex;align-items: center;">
              <div style="width: 8px;height: 8px;border-radius: 50%;margin-right: 5px;background-color: #00FFF7;"></div>
              <div style="font-size: 14px;color: #ccc;">资金用途</div>
            </div>
            <div style="margin-top: 5px;">
              <div style="font-size: 14px;color: #fff;">{{ info.useFunds }}</div>
            </div>
            <div style="margin-top: 20px;display: flex;align-items: center;">
              <div style="width: 8px;height: 8px;border-radius: 50%;margin-right: 5px;background-color: #00FFF7;"></div>
              <div style="font-size: 14px;color: #ccc;">申请公司</div>
            </div>
            <div style="margin-top: 5px;">
              <div style="font-size: 14px;color: #fff;">{{info.estateName}}</div>
            </div>
            <div style="margin-top: 20px;display: flex;align-items: center;">
              <div style="width: 8px;height: 8px;border-radius: 50%;margin-right: 5px;background-color: #00FFF7;"></div>
              <div style="font-size: 14px;color: #ccc;">备注</div>
            </div>
            <div style="margin-top: 5px;">
              <div style="font-size: 14px;color: #fff;">{{info.remake}}</div>
            </div>
            <div style="margin-top: 30px;display: flex;align-items: center;justify-content: space-between;border-bottom: 1px solid #1E524F; padding-bottom: 10px;">
              <div style="display: flex;align-items: center;">
                <div style="font-size: 14px;color: #ccc;margin-right: 10px;">申请金额</div>
                <div style="font-size: 14px;color: #fff;">￥{{info.applicationAmount}}</div>
              </div>
              <div style="display: flex;align-items: center;">
                <div style="font-size: 14px;color: #ccc;margin-right: 10px;">申请人</div>
                <div style="font-size: 14px;color: #fff;">{{info.applicationUser}}</div>
              </div>
              <div style="display: flex;align-items: center;">
                <div style="font-size: 14px;color: #ccc;margin-right: 10px;">申请时间</div>
                <div style="font-size: 14px;color: #fff;">{{info.applicationTime}}</div>
              </div>
            </div>
            <div style="display: flex;margin-top: 20px;">
              <div style="display: flex; background: linear-gradient( 360deg, #06585A 0%, rgba(0,59,61,0.3) 100%);padding: 10px;margin-right: 10px;border-radius: 10px;" v-for="item in info.attachmentUrl" :key="item">
                <img src="@/assets/file.png" alt="" style="width: 80px;height: 80px;vertical-align: bottom;">
                <div style="display: flex;flex-direction: column; margin-left: 10px;">
                  <div style="font-size: 14px;color: #fff; width: 100px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.name }}</div>
                  <div style="margin-top: auto;display: flex;align-items: center;justify-content: end;">
                    <i class="el-icon-download" style="color: #0EE0D4;"></i>
                    <div style="font-size: 14px;color: #0EE0D4;" @click="onDownload(item.url)">下载</div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {funddetail} from "@/api/estate";
export default {
  name: 'info',
  data() {
    return {
      info: {
        id: '',
        title: '申请事项名称',
        content: '',
        status: '',
        apply_time: '2025-10-30 11:58:10',
        apply_matter: '资金用途描述资金用途描述资金用途描述资金用途描述资金用途描述资金用途描述资金用途描述资金用途描资金用途描资金用途描',
        apply_reason: '原因描述原因描述原因描述原因描述原因描述原因描述原因描述原因描述原因描述原因描述原因描述原因描述',
        apply_user: '张三',
        estateName: '123456',
        price: '10000',
      }
    }
  },
  mounted() {
    this.$on('onDetail',(id)=>{
      // console.log(id);
      if(id){
        this.funddetail(id)
      }
    })
  },
  methods: {
    onDownload(item) {
      window.open(item, '_blank')
    },
    funddetail(id){
      funddetail({id:id}).then(res => {
        this.info = res.data;
        if (!Array.isArray(this.info.attachmentUrl)) {
            // 如果是字符串类型
            if (typeof this.info.attachmentUrl === 'string' && this.info.attachmentUrl) {
                // 使用逗号分割字符串并处理每个URL
                this.info.attachmentUrl = this.info.attachmentUrl.split(',').map(url => {
                    // 从URL中提取文件名
                    const fileName = url.split('/').pop() || '未命名文件';
                    // 返回包含URL和文件名的对象
                    return {
                        url: url.trim(),
                        name: fileName
                    };
                });
            } else {
                // 如果不是字符串，初始化为空数组
                this.info.attachmentUrl = []; 
            }
        }
      })
    },
    navBack() {
      this.$emit('onBack');
    }
  }
}
</script>

<style scoped>
.scroll-container {
    padding: 20px;
    width: 1280px;
    height: 710px;
    background: rgba(0,0,0,0.7);
}

.scroll-wrapper {
    width: 1250px;
    height: 670px;
    background-color: rgba(18, 59, 55, 0.3);
    padding: 15px;
}

.infinite-list-item {
    margin-top: 15px;
    margin-right: 10px;
}

.event-list {
  display: flex;
  flex-direction: column;
  /* align-items: center; */
}

.event-list-container {
  background-color: rgb(4, 13, 16, 0.8);
  color: #fff;
  padding: 20px;
  width: 1320px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  position: relative;
}

.event-items {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.title {
    text-align: center;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
}

</style>
